import { CSSObject } from '@chakra-ui/react';

export const BoxHeaderWrapper: CSSObject = {
  display: 'flex',
  alignItems: 'flex-start',
  flexDir: 'column',
  color: 'white',
  fontWeight: 'medium',
  height: 'auto',
  border: 'none',
  mx: [2, 0],
  pb: 0,
  svg: {
    color: 'beta.400',
    mr: '1',
  },
};

export const FlexHeadingMiscWrapper: CSSObject = {
  zIndex: '1',
  '.chakra-badge.state-inprogress': {
    color: 'black',
  },
  '&&&&': {
    fontSize: 'xs',
    flexDir: ['column', 'row'],
    alignItems: ['flex-start', 'center'],

    '.timestamp': {
      fontSize: 'inherit',
      fontWeight: 'inherit',
      color: 'beta.400',
    },
  },
};

export const BoxDot: CSSObject = {
  display: ['none', 'block'],
  bg: 'white',
  border: 'none',
};

export const TextSportName: CSSObject = {
  color: 'beta.400',
  '&&&&': {
    fontSize: 'inherit',
    fontWeight: 'inherit',
  },
};
